import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=169bb310&scoped=true&"
import script from "./MenuTree.vue?vue&type=script&lang=js&"
export * from "./MenuTree.vue?vue&type=script&lang=js&"
import style0 from "./MenuTree.vue?vue&type=style&index=0&id=169bb310&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169bb310",
  null
  
)

export default component.exports